// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"77a9b881","531":"d2ca334f","609":"67a31d21","787":"28cb0dcd","893":"fc04a141"}[chunkId] + ".chunk.js";
};